import { loadStripe } from '@stripe/stripe-js';
import { post } from 'aws-amplify/api';
import { isDemoEnv } from '../utils/environment';

const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
const API_BASE_URL = 'billivoRegister';

const isDemo = isDemoEnv;

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY as string);

const getAuthHeaders = async () => {
  return {
    'x-api-key': process.env.REACT_APP_API_GATEWAY_KEY as string,
    'Content-Type': 'application/json',
  };
};

interface ApiCredentials {
  username: string;
  email: string;
  password: string;
  clientId?: string;
  userPoolId?: string;
}

interface CheckoutResponse {
  url?: string;
  id?: string;
  subscription?: any;
  apiCredentials?: ApiCredentials;
}

export const createCheckoutSession = async (
  data: any,
  token: string,
): Promise<CheckoutResponse> => {
  try {
    const headers = await getAuthHeaders();

    // First call to userHandler
    const userResponse = await post({
      apiName: `${API_BASE_URL}`,
      path: '/userHandler',
      options: {
        headers,
        body: {
          ...data,
          skipStripe: isDemo, // In demo mode, don't create Stripe customer/subscription
          token,
        },
      },
    });

    // Check for error in userHandler response
    const userResponseBody = await (await userResponse.response).body;
    const userResponseJson = await userResponseBody.json();
    if (
      userResponseJson &&
      typeof userResponseJson === 'object' &&
      'statusCode' in userResponseJson &&
      userResponseJson.statusCode !== 200 &&
      userResponseJson.statusCode !== 201
    ) {
      throw new Error(
        (userResponseJson as any).error ||
          (userResponseJson as any).message ||
          'Error en el registro de usuario',
      );
    }
    if (
      userResponseJson &&
      typeof userResponseJson === 'object' &&
      'error' in userResponseJson &&
      (userResponseJson as any).error
    ) {
      throw new Error((userResponseJson as any).error);
    }

    // Extract API credentials if present (demo mode)
    const apiCredentials = (userResponseJson as any)?.apiCredentials;

    // In demo mode, skip stripeHandler and return directly
    if (isDemo) {
      return { subscription: true, apiCredentials };
    }

    return userResponseJson as unknown as CheckoutResponse;
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};
